/**
 * Password policy — compartida entre Signup, ResetPassword y la card de
 * cambiar contraseña en /account/profile. ROUND10.
 *
 * Reglas: 8+ caracteres, al menos una mayúscula, un número y un símbolo
 * (cualquier carácter que no sea letra ni dígito). Política consistente
 * con el resto de surfaces (web/, app/, admin/).
 */

/** Hint legible para mostrar debajo del input. */
export const PASSWORD_POLICY_HINT =
  'Mínimo 8 caracteres con al menos una mayúscula, un número y un símbolo.';

export type PasswordValidation = { ok: true } | { ok: false; message: string };

/**
 * Valida una contraseña contra la política. Si falla devuelve un mensaje
 * que enumera lo que falta para que el usuario pueda corregir en un solo
 * intento.
 */
export function validatePassword(pwd: string): PasswordValidation {
  const issues: string[] = [];
  if (pwd.length < 8) issues.push('al menos 8 caracteres');
  if (!/[A-Z]/.test(pwd)) issues.push('una mayúscula');
  if (!/\d/.test(pwd)) issues.push('un número');
  if (!/[^A-Za-z0-9]/.test(pwd)) issues.push('un símbolo (ej. ! @ # $)');
  if (issues.length === 0) return { ok: true };
  return { ok: false, message: `La contraseña debe tener ${issues.join(', ')}.` };
}
